/** DB 메뉴 platform 컬럼과 동일한 값 */
export const MenuPlatform = {
    COMMON: "COMMON",
    ASSET: "ASSET",
    ITM: "ITM",
    IAM: "IAM",
    SRM: "SRM",
};

/**
 * @param {string|undefined} menuPlatform - COMMON | ASSET | ITM | IAM | SRM
 * @param {string|undefined} platFrom - auth.platFrom (ITM | IAM | SRM)
 *
 * COMMON  → 전 플랫폼
 * ASSET   → ITM, IAM
 * ITM     → ITM만 (SRM에서는 숨김)
 * IAM     → IAM만
 * SRM     → ITM, SRM (ITM에서 서비스요청 등 SRM 메뉴도 노출)
 */
export function isVisibleForPlatform(menuPlatform, platFrom) {
    if (!menuPlatform || menuPlatform === MenuPlatform.COMMON) {
        return true;
    }
    if (menuPlatform === MenuPlatform.ASSET) {
        return platFrom === "ITM" || platFrom === "IAM";
    }
    if (menuPlatform === MenuPlatform.ITM) {
        return platFrom === "ITM";
    }
    if (menuPlatform === MenuPlatform.IAM) {
        return platFrom === "IAM";
    }
    if (menuPlatform === MenuPlatform.SRM) {
        return platFrom === "ITM" || platFrom === "SRM";
    }
    return menuPlatform === platFrom;
}

export function filterCategoriesByPlatform(categories, platFrom) {
    return (categories ?? []).filter((item) => isVisibleForPlatform(item.platform, platFrom));
}

/**
 * 플랫폼에서 보이는 항목 중 preferredId를 선택, 없으면 첫 항목
 */
export function pickActiveCategoryId(categories, preferredId, platFrom) {
    const visible = filterCategoriesByPlatform(categories, platFrom);
    if (!visible.length) {
        return null;
    }
    if (preferredId && visible.some((item) => item.id === preferredId)) {
        return preferredId;
    }
    return visible[0].id;
}
